import { render, staticRenderFns } from "./seniority-remuneration-table.view.vue?vue&type=template&id=22a187b0&scoped=true&"
import script from "./seniority-remuneration-table.view.vue?vue&type=script&lang=ts&"
export * from "./seniority-remuneration-table.view.vue?vue&type=script&lang=ts&"
import style0 from "./seniority-remuneration-table.view.vue?vue&type=style&index=0&id=22a187b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a187b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
